import Vue from "vue";
import App from "./App.vue";

import AOS from "aos";

Vue.config.productionTip = false;

import SocialSharing from "vue-social-sharing";
Vue.use(SocialSharing);

import VueSweetalert2 from "vue-sweetalert2";

const options = {
  confirmButtonColor: "#e30613"
  // cancelButtonColor: '#ff7674'
};

Vue.use(VueSweetalert2, options);

import VueYandexMetrika from "vue-yandex-metrika";
import VueAnalytics from "vue-analytics";
Vue.use(VueYandexMetrika, {
  id: 41379194,
  env: process.env.NODE_ENV
});

Vue.use(VueAnalytics, {
  id: "UA-88014128-28",
  // debug: {
  //   enabled: true,
  //   trace: false,
  //   sendHitTask: true
  // }
});

import VueFire from 'vuefire'

Vue.use(VueFire);

new Vue({
  created() {
    AOS.init({
      delay: 100, // values from 0 to 3000, with step 50ms
      duration: 500 // values from 0 to 3000, with step 50ms
    });
  },
  render: h => h(App)
}).$mount("#app");
